import { toString } from 'lodash';

import { OrganizationTypes } from '@/common/constants';
import { IClaimsTeamInfoDto, IContactInfoDto } from '@/dtos';

export interface TeamMemberPayload {
  id?: number;
  contact_id?: number;
  contact_type?: OrganizationTypes;
  first_name?: string;
  last_name?: string;
  email?: string;
  role_name?: string;
  icon?: string;
}
export interface TeamMember {
  id?: string;
  fullName?: string;
  email?: string;
  role?: string;
  type?: OrganizationTypes;
  icon?: string;
}

export interface TeamOrganization {
  id: string;
  name: string;
  children?: TeamOrganization[];
}

export interface TeamPayload {
  id?: number;
  name?: string;
  organization_id?: number;
  assigned_organizations: TeamOrganization[];
  org_path?: string;
  allowed_services?: number[];
  is_default?: boolean;
  is_generic_claims_team?: boolean;
}
export interface Team {
  id?: string;
  name?: string;
  organizationId?: string;
  orgPath?: string;
  allowedServices?: string[];
  assignedOrganizations?: TeamOrganization[];
  isDefault?: boolean;
  isGenericClaimsTeam?: boolean;
}

export interface ClaimsTeamPayload extends TeamPayload {
  assigned_contacts?: TeamMemberPayload[];
}

export interface ClaimsTeam extends Team {
  teamMembers?: TeamMember[];
}

export interface ClaimsProcessorPayload extends TeamMemberPayload {
  claims_teams?: TeamPayload[];
}

export interface ClaimsProcessor extends TeamMember {
  teams?: Team[];
}

export const formatTeamPayload = (item: IClaimsTeamInfoDto): ClaimsTeam => ({
  id: toString(item?.id),
  name: item?.name,
  organizationId: toString(item?.organization_id),
  orgPath: item?.org_path,
  allowedServices: item?.allowed_services?.map((id) => toString(id)),
  // @ts-ignore
  isDefault: item?.is_default || false,
  teamMembers: item?.assigned_contacts?.map((member) => ({
    id: toString(member?.contact_id),
    // @ts-ignore
    icon: member?.icon,
    fullName: `${member?.first_name} ${member?.last_name}`.trim(),
    role: member?.role_name,
  })),
  assignedOrganizations: item?.assigned_organizations?.map(
    (org): TeamOrganization => ({
      id: toString(org?.id),
      name: org?.name || '',
      // @ts-ignore
      children: org?.children,
    })
  ),
  isGenericClaimsTeam: item?.is_generic_claims_team,
});

export const formatClaimsProcessorPayload = (item: IContactInfoDto): ClaimsProcessor => ({
  id: toString(item?.id),
  fullName: `${item?.first_name} ${item?.last_name}`.trim(),
  email: item?.email,
  role: item?.role_name,
  type: item?.contact_type as unknown as OrganizationTypes,
  // @ts-ignore
  icon: item?.icon,
  teams: item?.claims_teams?.map((team) => ({
    id: toString(team?.id),
    name: team?.name,
    allowedServices: team?.allowed_services?.map((id) => toString(id)),
  })),
});

export interface ClaimsTeamConfig {
  name: string;
  allowedServices: string[];
  assignedOrganizationIds?: number[];
  isGenericClaimsTeam?: boolean;
}

export interface ClaimsTeamConfigPayload {
  name: string;
  allowed_services: number[];
  assigned_organizations_ids?: number[];
  is_generic_claims_team: boolean;
}
